import { Type } from '@sinclair/typebox';
import { ProjectWorkspaceStatusSchema } from './contracts/project-workspace/project-workspace-schema.js';
import { UserRole } from './fortnox-user-schema.js';
// `sharePoint` lives only on the list schema (not on `AdminProjectSchema`, which doubles as the
// PUT /project/:projectId request body) — the chips are rendered from the list the client already
// fetches, and adding a required-shaped field to the PUT body would break project updates.
export const ListAdminProjectSchema = Type.Object({
    id: Type.String(),
    fortnoxId: Type.String(),
    name: Type.String(),
    sharePoint: Type.Union([ProjectWorkspaceStatusSchema, Type.Null()]),
});
export const ListAdminProjectsResponseSchema = Type.Array(ListAdminProjectSchema);
export const CreateProjectBodySchema = Type.Object({
    fortnoxId: Type.String(),
    name: Type.String(),
});
// `POST /project` answers with `ListAdminProjectsResponseSchema` — there is deliberately no separate
// create-response schema. A dedicated one existed and drifted: it never carried `sharePoint`, so the
// client typed the create call against a shape the server had stopped sending.
export const ListAdminProjectParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const AdminProjectSchema = Type.Object({
    id: Type.String(),
    fortnoxId: Type.String(),
    name: Type.String(),
});
export const UpdateProjectSchema = Type.Object({
    id: Type.String(),
    fortnoxId: Type.String(),
    name: Type.String(),
});
export const ProjectUsersParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const ProjectUsersSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    email: Type.String(),
    phone: Type.String(),
    role: Type.Enum(UserRole),
});
export const ProjectUsersResponseSchema = Type.Array(ProjectUsersSchema);
const PhoneRegex = /^\+?[ 0-9-]+$/;
const ValidPhoneNumber = Type.String({
    pattern: PhoneRegex.source,
});
const EmptyString = Type.Literal('');
export const UpdateUserSettingsSchema = Type.Object({
    name: Type.String({ minLength: 1 }),
    phone: Type.Union([ValidPhoneNumber, EmptyString]),
    role: Type.Enum(UserRole),
});
export const UpdateUsersSettingsParamSchema = Type.Object({
    userId: Type.String(),
});
